import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {TableRequest} from "../../../model/api/table-request";
import {TableButtonConfig} from "../../../model/api/table-button-config";
import {ReportTask} from "../../../model/archive/report-task";
import {ReportTaskService} from "../../../services/archive/report-task.service";
import {ReportTaskLoadRequest} from "../../../model/archive/report-task-load-request";

@Component({
  selector: 'app-invoice-tasks',
  templateUrl: './invoice-tasks.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceTasksComponent extends CcBaseComponent {

  transPartKey: string = 'billing.task';

  tableConfig: TableColumnConfig[] = [];

  headerButtonConfig: TableButtonConfig[] = [];

  contextMenuConfig: MenuItem[] = [];
  formRecord: ReportTask;
  selectedRecords: ReportTask[];
  records: ReportTask[];
  recordsChange = new EventEmitter<ReportTask[]>();

  totalRecords: number = 0;

  tableLoading: boolean = true;

  tableCurrentRequest: ReportTaskLoadRequest;
  tableCurrentRequestChange = new EventEmitter<TableRequest>();

  origins: string[];

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              protected reportTaskService: ReportTaskService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

    this.origins = [ReportTask.Origin.BILLING, ReportTask.Origin.SYSTEM_BILLING];
  }

}
